import { capitalize, capitalizeFirstLetter } from "helpers/utils"
import Label from "components/general/Label"
import { ColumnIrmOrValue } from "components/common/TableColumns"
import SportCode from "components/common/SportCode"

export function createColumns(config, discipline) {
    console.log("Colums:", config)
    let columnsExt = []
    Array.isArray(config) &&
        config.forEach((item) => {
            if (item.irm !== undefined && typeof item === 'object') {
                columnsExt.push(
                    ColumnIrmOrValue({
                        label: item?.config?.header,
                        className: item?.config?.class ? item?.config?.class : "text-end",
                        id: item.id,
                        isPoolStandings: true
                    })
                )

            } else if (typeof item === 'object') {
                columnsExt.push(
                    {
                        id: capitalize(item.id),
                        // Header: item?.config?.header && <Label data={item?.config?.header} sport={discipline} />,
                        Header: (item?.id === 'qualificationMark' && discipline === 'BK3') ? '' : item?.config?.header && <Label data={item?.config?.header} sport={discipline} legendFixed={true} />,
                        headerClassName: item?.config?.headerClassName ? item?.config?.headerClassName : "w-5 text-end",
                        accessor: item.id,
                        disableSortBy: true,
                        className: item?.config?.className ? item?.config?.className : (item.id === "qualificationMark") ? "text-end fw-bold" : "text-end",
                        Cell: (props) => {
                            const row = props.cell.row.original;
                            const qualificationMark = row?.qualificationMark;
                            let out
                            if (item.id === 'qualificationMark' && qualificationMark) {
                                out = <SportCode code={qualificationMark} entity="@QualificationMark" abbr={true} />
                            } else {
                                out = row[item.id]
                            }
                            return (out)
                        }
                    },
                )
            } else {
                columnsExt.push(
                    {
                        id: capitalize(item),
                        Header: <Label data={labeledHeader(capitalizeFirstLetter(item))} legendFixed={true} />,
                        headerClassName: "w-5 text-end",
                        accessor: item,
                        disableSortBy: true,
                        className: "text-end"
                    },
                )
            }
        })

    return columnsExt
}

function labeledHeader(str) {
    return "Header" + str;
}

export const CaptionTable = ({ caption }) => {
    return (
        <span>
            {caption}
        </span>
    );
}
